module.exports = __webpack_public_path__ + "static/media/dj.96022cb9.png";